var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      staticStyle: { "enable-background": "new 0 0 57.525 95.025" },
      attrs: {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 57.525 95.025",
        "xml:space": "preserve",
      },
    },
    [
      _c("g", { attrs: { id: "Layer_2" } }),
      _vm._v(" "),
      _c("g", { attrs: { id: "Layer_1" } }, [
        _c("path", {
          staticClass: "st0",
          attrs: {
            d: "M10.025,95.025c-2.6,0-5.1-1-7.1-2.9c-3.9-3.9-3.9-10.3,0-14.2l30.3-30.4l-30.3-30.4c-3.9-3.9-3.9-10.3,0-14.2\ns10.3-3.9,14.2,0l37.5,37.5c1.9,1.9,2.9,4.4,2.9,7.1s-1.1,5.2-2.9,7.1l-37.5,37.5C15.125,94.025,12.525,95.025,10.025,95.025z",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }